import type { TranslationKey } from "../locales";

/**
 * This function is used to get the title string for a given title.
 * @param title
 * @returns
 */
export function getTitleTranslationKey(title: unknown | null): TranslationKey {
	if (typeof title === "string") {
		if (!title) return "--";
		if (title === "mr") return "profile.mr";
		return "profile.mrs";
	}
	return "--";
}
